import { GateMovementState2 as MovementState } from '@/__generated__/graphql';

/**
 * Vive aparte de `gateMovementState.tsx` para que la subscription global lo use sin cargar la
 * figura y los íconos de MUI que ese módulo trae.
 */
const FINALIZED_STATES = [MovementState.Finalized, MovementState.FinalizedWithError];

export const isFinalizedState = (state: MovementState) => {
  return FINALIZED_STATES.includes(state);
};
